import {LOCALE_ID, ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {NbAuthJWTToken, NbAuthModule, NbPasswordAuthStrategy} from '@nebular/auth';
import {NbRoleProvider, NbSecurityModule} from '@nebular/security';
import {of as observableOf} from 'rxjs';

import {throwIfAlreadyLoaded} from './module-import-guard';
import {AnalyticsService, LayoutService, SeoService, StateService} from './utils';
import {environment} from '../../environments/environment';
import {UserService} from './api/users.service';
import {AuthGuard} from '../pages/auth/auth-guard.service';
import {GoogleLoginProvider, SocialAuthServiceConfig} from '@abacritt/angularx-social-login';
import {AuthenticationService} from './api/authentication.service';
import localeUk from '@angular/common/locales/uk'; // Import Ukrainian locale data

// Register the locale data
registerLocaleData(localeUk);

const socialLinks = [
  {
    target: '_blank',
    icon: 'google',
  },
];

const DATA_SERVICES = [
  UserService,
  AuthGuard,
  AuthenticationService,
];

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf('guest');
  }
}

export const NB_CORE_PROVIDERS = [
  ...DATA_SERVICES,
  ...NbAuthModule.forRoot({

    strategies: [
      NbPasswordAuthStrategy.setup({
        name: 'email',
        baseEndpoint: environment.api.baseUrl,
        login: {
          endpoint: environment.api.authLogin,
          method: 'post',
          defaultErrors: ['Перевірте дані.'],
        },
        register: {
          endpoint: environment.api.authSignUp,
          method: 'post',
          defaultErrors: ['Не дозволена дія.'],
          defaultMessages: ['Ви вийшли успішно.'],
        },
        token: {
          class: NbAuthJWTToken,
          key: 'token',
        },
        logout: {
          alwaysFail: false,
          endpoint: '',
          redirect: {
            success: '/',
            failure: '/',
          },
          defaultErrors: ['Не дозволена дія.'],
          defaultMessages: ['Ви вийшли успішно.'],
        },
      }),
    ],
    forms: {
      login: {
        socialLinks: socialLinks,
      },
      register: {
        socialLinks: socialLinks,
      },
    },
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: '*',
      },
      user: {
        parent: 'guest',
        create: '*',
        edit: '*',
        remove: '*',
      },
    },
  }).providers,

  {
    provide: NbRoleProvider, useClass: NbSimpleRoleProvider,
  },
  { provide: LOCALE_ID, useValue: 'uk-UA' }, // Set the desired locale
  AnalyticsService,
  LayoutService,
  SeoService,
  StateService,
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    NbAuthModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
        {
          provide: 'SocialAuthServiceConfig',
          useValue: {
            autoLogin: false,
            providers: [
              {
                id: GoogleLoginProvider.PROVIDER_ID,
                provider: new GoogleLoginProvider(
                  environment.api.auth.googleClientId,
                ),
              },
            ],
            onError: (err) => {
              console.error(err);
            },
          } as SocialAuthServiceConfig,
        },
      ],
    };
  }
}
